// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__Aezao","col":"styles_col__Mo73k"};